import React from 'react'

import { useClickOutside } from '../../../../core/hooks'
import { FilterSections } from '../../FilterBarTypes'
import { useFilterBar } from '../../providers'

import { Dates } from './Dates/Dates'
import { Guests } from './Guests/Guests'
import { Locations } from './Locations/Locations'

import './FilterPanels.css'
import { usePanelPosition } from '../../hooks'

export const FilterPanels = () => {
  const {
    calendarRange,
    selectedFilter,
    selectedPath,
    ageCategoryCounts,
    selectedLocations,
    mode,
    disableCalendarDates,
    ageCategories,
    locations,
    language,
    panelRef,
    buttonRefs,
    filtersRef,
    setSelectedLocations,
    setCalendarRange,
    handleSelectedFilter,
    updateGuestsCount,
  } = useFilterBar()

  const filterSectionRef = useClickOutside<HTMLDivElement>(() =>
    handleSelectedFilter(false)
  )

  usePanelPosition({
    selectedFilter,
    panelRef,
    filtersRef,
    buttonRefs,
  })

  const renderContent = () => {
    switch (selectedFilter) {
      case FilterSections.CALENDAR:
        return (
          <Dates
            autoFocus
            ref={filterSectionRef}
            onClose={() => handleSelectedFilter(false)}
            calendarRange={calendarRange}
            setCalendarRange={setCalendarRange}
            disableCalendarDates={disableCalendarDates}
            selectedPath={selectedPath}
            language={language}
          />
        )
      case FilterSections.GUESTS:
        return (
          <Guests
            autoFocus
            ref={filterSectionRef}
            ageCategories={ageCategories}
            ageCategoryCounts={ageCategoryCounts}
            updateGuestsCount={updateGuestsCount}
            onClose={() => handleSelectedFilter(false)}
          />
        )
      case FilterSections.LOCATIONS:
        return (
          <Locations
            autoFocus
            ref={filterSectionRef}
            locations={locations?.data}
            selectedLocations={selectedLocations}
            setSelectedLocations={setSelectedLocations}
            multiSelect={locations?.multiSelect}
            onClose={() => handleSelectedFilter(false)}
          />
        )

      default:
        return null
    }
  }

  return (
    selectedFilter && (
      <div
        ref={panelRef}
        className={`will-filter-bar-panels ${mode || 'light'}`}
      >
        {renderContent()}
      </div>
    )
  )
}
